import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { Form, Email } from '@grandvisionhq/forms';

const GuestForm = ({ labels , formName , onSubmit  })=>{
    const [signUpForm] = React.useState({
        email: {
            name: 'email',
            isTouched: false,
            isValid: false,
            value: ''
        }
    });
    const handleSubmit = (state)=>{
        var ref;
        const { formState  } = state;
        if (formState === null || formState === void 0 ? void 0 : (ref = formState.email) === null || ref === void 0 ? void 0 : ref.isValid) {
            onSubmit(formState.email.value);
            return;
        }
    };
    return /*#__PURE__*/ React.createElement(Form, {
        onSubmit: handleSubmit,
        initialFormState: signUpForm,
        name: formName,
        "data-t": "signup-form",
        showErrorsOnInvalidSubmit: false,
        className: "back-in-stock-modal__form"
    }, /*#__PURE__*/ React.createElement(Email, {
        "data-t": "email",
        required: true,
        label: labels.emailLabel,
        errorMessage: labels.emailError,
        placeholder: labels.emailLabel
    }), /*#__PURE__*/ React.createElement(Text, {
        variant: "caption"
    }, labels.consentMessage));
};

export { GuestForm as default };
//# sourceMappingURL=GuestForm.js.map
